"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _reduce = _interopRequireDefault(require("lodash/reduce"));
var _get = _interopRequireDefault(require("lodash/get"));
var _JPlayerFactory = _interopRequireDefault(require("./jplayer/JPlayerFactory"));
var _HlsJsPlayerFactory = _interopRequireDefault(require("./hlsjs/HlsJsPlayerFactory"));
var _WindowsMediaPlayerFactory = _interopRequireDefault(require("./wmp/WindowsMediaPlayerFactory"));
var _WebMediaPlayerFactory = _interopRequireDefault(require("./webmediaplayer/WebMediaPlayerFactory"));
var _players = _interopRequireDefault(require("./constants/players"));
var _debugger = _interopRequireDefault(require("../debugger"));
/* eslint-disable no-underscore-dangle */
var PlayerCache = exports["default"] = /*#__PURE__*/function () {
  function PlayerCache(configuration) {
    var queueSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    (0, _classCallCheck2["default"])(this, PlayerCache);
    this.queueSize = queueSize;
    this.cache = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _players["default"].hlsjs, {
      queue: [],
      factory: new _HlsJsPlayerFactory["default"]((0, _get["default"])(configuration, 'resources.fetchHlsJsLibrary'))
    }), _players["default"].wmp, {
      queue: [],
      factory: new _WindowsMediaPlayerFactory["default"]((0, _get["default"])(configuration, 'blankMp3Url'))
    });
    if (configuration.isWebMediaPlayerEnabled) {
      this.cache[_players["default"].webmediaplayer] = {
        queue: [],
        factory: new _WebMediaPlayerFactory["default"]((0, _get["default"])(configuration, 'blankMp3Url'))
      };
    } else {
      this.cache[_players["default"].jplayer] = {
        queue: [],
        factory: new _JPlayerFactory["default"]()
      };
    }

    // Load the cache when PlayerCache is instantiated.
    this._load();
  }
  (0, _createClass2["default"])(PlayerCache, [{
    key: "allPlayers",
    get: function get() {
      return (0, _reduce["default"])(this.cache, function (allPlayers, playerConfig) {
        return allPlayers.concat(playerConfig.queue);
      }, []);
    }
  }, {
    key: "setPlayer",
    value: function setPlayer(name) {
      var config = this.cache[name];
      if (!config) {
        return;
      }
      if (config.queue.length >= this.queueSize) {
        return;
      }
      try {
        var player = config.factory.createPlayer();
        if (!player) {
          return;
        }
        config.queue.push(player);
      } catch (ex) {
        _debugger["default"].log('Could not create player ' + name, ex);
      }
    }
  }, {
    key: "getPlayer",
    value: function () {
      var _getPlayer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(name) {
        var config, player;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              config = this.cache[name];
              if (config) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", null);
            case 3:
              player = config.queue.shift();
              if (player) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", null);
            case 6:
              _context.prev = 6;
              _context.next = 9;
              return player.init();
            case 9:
              return _context.abrupt("return", player);
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](6);
              _debugger["default"].log('Could not initialize cached player ' + player, _context.t0);
              return _context.abrupt("return", null);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 12]]);
      }));
      function getPlayer(_x) {
        return _getPlayer.apply(this, arguments);
      }
      return getPlayer;
    }()
  }, {
    key: "_load",
    value: function _load() {
      var _this = this;
      (0, _forEach["default"])(this.cache, function (playerConfig, playerName) {
        for (var i = 0; i < _this.queueSize; i++) {
          _this.setPlayer(playerName);
        }
      });
    }
  }]);
  return PlayerCache;
}();
//# sourceMappingURL=PlayerCache.js.map